// extracted by mini-css-extract-plugin
export var askAiIcon = "_js-9";
export var container = "_js-0";
export var groupSeparator = "_js-a";
export var highlight = "_js-4";
export var resultIcon = "_js-5";
export var resultItem = "_js-7";
export var resultSubtitle = "_js-3";
export var resultTitle = "_js-2";
export var resultsList = "_js-1";
export var searchGroup = "_js-6";
export var selected = "_js-8";